export var REPLACE_DOMAIN_WHITE_LIST = ['bybit.com', 'bybitglobal.com', 'bytick.com', 'bybit-global.com', 'bybit.biz', 'bybit.global', 'bybit.org', 'bybits.org', 'bybitgum.com', 'bybitgum.org', 'bybits.io', 'bybit.cloud', 'bybitx.global', 'byhkbit.com', 'bybit.nl', 'bybit.ae', 'bybit.com.hk', 'bybit-tr.com', 'bybit.kz', 'bybit.eu', 'bybit-ge.com', 'bybit.id'];

// 获取content的Announcements, Blog, Learn的域名
export var getContentDomain = function getContentDomain(contentType) {
  if (typeof window !== 'undefined') {
    var protocol = window.location.protocol;
    var hostname = window.location.hostname;
    var isInWhiteList = REPLACE_DOMAIN_WHITE_LIST.some(function (host) {
      return hostname.match(new RegExp("".concat(host, "$")));
    });
    if (!isInWhiteList) {
      hostname = 'www.bybit.com';
    }
    if (hostname.endsWith('.ae')) {
      hostname = hostname.replace(/\.ae$/, '.com');
    }
    if (hostname.endsWith('.nl') && contentType === 'blog') {
      hostname = hostname.replace(/\.nl$/, '.com');
    }

    // learn/blog没有hk域名
    if (hostname.endsWith('.com.hk') && ['blog', 'learn'].includes(contentType)) {
      hostname = hostname.replace(/\.com\.hk$/, '.com');
    }

    // learn/blog没有byhkbit.com域名
    if (hostname.endsWith('.byhkbit.com') && ['blog', 'learn'].includes(contentType)) {
      hostname = hostname.replace(/\.byhkbit\.com$/, '.bybit.com');
    }
    hostname = hostname.split('.');
    if (hostname.length <= 2) return "".concat(protocol, "//").concat(contentType, ".bybit.com");
    var subdomain = hostname[0];
    var testnetSubdomain = contentType === 'blog' ? 'newblog' : contentType;
    subdomain = subdomain.includes('testnet') ? "testnet-".concat(testnetSubdomain) : contentType;
    hostname[0] = subdomain;
    return "".concat(protocol, "//").concat(hostname.join('.'));
  }
  return '';
};
export var replaceContentDomain = function replaceContentDomain(urlString) {
  if (typeof window !== 'undefined') {
    var _url$hostname$match;
    var url = new URL(urlString);
    var contentType = (_url$hostname$match = url.hostname.match(/learn|blog|announcements/)) === null || _url$hostname$match === void 0 ? void 0 : _url$hostname$match[0];
    if (!contentType) {
      return urlString;
    }
    var contentDomain = new URL(getContentDomain(contentType));
    url.hostname = contentDomain.hostname;
    return url.toString();
  }
  return urlString;
};